document.addEventListener('DOMContentLoaded', function () {
  if (!window.__tgmShowBuy2Save30) return;

  var btn = document.querySelector('.main-product-atc');
  if (!btn) return;

  var container = btn.closest('.product-form__buttons');
  if (!container || container.parentNode.querySelector('.tgm-buy2save30-badge')) return;

  var badge = document.createElement('p');
  badge.className = 'tgm-buy2save30-badge';
  // Cart rewards (03-10-2026): the Buy 2 save 30 offer is replaced by the volume tiers. The percent
  // comes from the tier 2 setting printed by tgm-cart-rewards.liquid, so the badge follows the editor.
  var pct = 10;
  try {
    var cfgEl = document.querySelector('[data-tgm-rewards-config]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : null;
    if (cfg && cfg.tiers && cfg.tiers[1] && cfg.tiers[1].pct) pct = cfg.tiers[1].pct;
  } catch (e) { /* keep 10 */ }
  badge.textContent = 'Buying 2? Get ' + pct + '% off + a free strap';
  container.insertAdjacentElement('afterend', badge);
});
